import { tns } from 'tiny-slider/src/tiny-slider';

class GridSlider {
    constructor(el) {
        this.el = el;

        const sliderContainer = this.el.closest('.block-grid__slider-container');
        const prevButton = sliderContainer.querySelector('.block-grid__slider-prev');
        const nextButton = sliderContainer.querySelector('.block-grid__slider-next');

        const itemLinks = Array.from(
            this.el.querySelectorAll('.block-grid__slider-item-link')
        );

        const gridSlider = tns({
            container: this.el,
            items: 1,
            responsive: {
                641: {
                    items: 2
                },
                1025: {
                    items: 3.8
                },
            },
            autoplay: false,
            autoplayButtonOutput: false,
            mouseDrag: true,
            preventScrollOnTouch: 'auto',
            swipeAngle: false,
            speed: 400,
            controls: true,
            prevButton: prevButton,
            nextButton: nextButton,
            gutter: 20
        });

		const updateLiveRegion = () => {
			const sliderInfo = gridSlider.getInfo();
			const liveRegion = sliderInfo.container
				.closest('.tns-outer')
				.querySelector('.tns-liveregion');

			liveRegion.textContent = `Slide ${sliderInfo.displayIndex} of ${sliderInfo.slideCount}`;
		};

		gridSlider.events.on('indexChanged', updateLiveRegion);
		updateLiveRegion();

        prevButton.setAttribute('tabindex', '0');
        nextButton.setAttribute('tabindex', '0');

        // Keep cloned Tiny Slider items out of the tab order.
        this.el.querySelectorAll('.block-grid__slider-item-link').forEach((link) => {
            link.setAttribute('tabindex', '-1');
        });

        // Original items remain keyboard accessible in their natural order.
        itemLinks.forEach((link, index) => {
            link.setAttribute('tabindex', '0');
            link.addEventListener('focus', () => {
                gridSlider.goTo(index);
            });
        });

        return gridSlider;
    }
}

export default GridSlider;
